export const TENANT_DETAILS_SAVE_BUTTON_TEXT = 'SAVE CHANGES';
export const TENANT_DETAILS_SAVE_SUCCESS_MESSAGE =
  'Success. Tenant details have been updated successfully.';
export const TENANT_DETAILS_LOAD_ERROR_DISPLAY_TEXT = 'An unexpected error occurred';
export const EDIT_TENANT_DETAILS_ERROR_DISPLAY_TEXT = 'Failed to save changes';
